// extracted by mini-css-extract-plugin
export default {"inputField":"MetadataModal_inputField__s-xPh","saveBtn":"MetadataModal_saveBtn__pDAHm"};